import { X } from 'lucide-react';

interface ViewTransferProofModalProps {
  open: boolean;
  /** The proof image; without it the modal says none has been uploaded */
  imageUrl?: string | null;
  onClose: () => void;
}

/** Bukti Transfer: shows the uploaded proof image. */
const ViewTransferProofModal = ({ open, imageUrl, onClose }: ViewTransferProofModalProps) => {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
      aria-labelledby="view-transfer-proof-title"
    >
      <button
        type="button"
        aria-label="Tutup"
        className="absolute inset-0 bg-black/50 cursor-default"
        onClick={onClose}
      />
      <div className="relative z-10 w-full max-w-[420px] rounded-xl bg-white p-6 flex flex-col gap-4">
        <div className="flex items-center justify-between gap-3">
          <p id="view-transfer-proof-title" className="title1bold">
            Bukti Transfer
          </p>
          <button
            type="button"
            aria-label="Tutup"
            onClick={onClose}
            className="shrink-0 text-black transition hover:opacity-80"
          >
            <X size={20} strokeWidth={2} />
          </button>
        </div>

        {imageUrl ? (
          <div className="max-h-[70vh] overflow-auto rounded-[8px] border border-blue-cs-200 bg-[#F6F6F6]">
            <img src={imageUrl} alt="Bukti transfer" className="w-full object-contain" />
          </div>
        ) : (
          <div className="flex items-center justify-center rounded-[8px] border border-blue-cs-200 bg-[#F6F6F6] px-4 py-10">
            <p className="body1 text-text-grey text-center">Bukti transfer belum tersedia.</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ViewTransferProofModal;
